import { getTypedStepValues } from "features/contracting/helpers/contractingFormHelper";
import ContractingStepSummaryProps from "features/contracting/models/ContractingStepSummaryProps";
import ProductStep from "features/contracting/models/steps/product/ProductStep";
import PageCard from "features/shared/components/card/PageCard";
import CheckValueInfoItem from "features/shared/components/infoItem/CheckValueInfoItem";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import React from "react";

const ProductSummary = ({
  contracting,
  step,
  configuration
}: ContractingStepSummaryProps) => {
  // translations
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "productSummary");

  // private props
  const values = getTypedStepValues<ProductStep>(
    contracting,
    step.component
  );

  // helpers
  const getProduct = (value: string) => {
    const product = configuration.products?.find((x) => x.code === value);
    return product?.name ? product.name : "-";
  };

  // render
  return (
    <PageCard title={tLabels("productCardTitle")} bodyClassName="px-4 py-3">
      <CheckValueInfoItem
        title={tLabels("productCode")}
        value={values.productCode}
        formatValue={getProduct}
      />
    </PageCard>
  );
};

export default ProductSummary;
